import React from 'react';

/**
 * SEOHead Component - Dynamic SEO meta tags for each page
 * Usage: <SEOHead title="Page Title" description="Page description" image="/path/to/image.jpg" />
 */
const SEOHead = ({ 
  title = "JMI — The B2B Jewellery Business Network",
  description = "The B2B jewellery business network connecting verified buyers, sellers and operators across India with live bullion pricing, structured wholesale orders, and insured fulfilment.",
  image = "/logo.png",
  url = "https://jewelmartindia.com",
  type = "website",
  keywords = "jewellery wholesale, B2B jewellery, gold buyers, gold sellers, bullion, BIS hallmarked jewellery, diamond jewellery, silver jewellery, jewellery franchise"
}) => {
  const fullTitle = title.includes("JMI") ? title : `${title} | JMI - Jewel Mart India`;
  
  return (
    <>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={url} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image.startsWith('http') ? image : `${window.location.origin}${image}`} />
      <meta property="og:image:type" content="image/png" />
      <meta property="og:image:alt" content={title} />
      <meta property="og:site_name" content="JMI - Jewel Mart India" />
      <meta property="og:locale" content="en_IN" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image.startsWith('http') ? image : `${window.location.origin}${image}`} />
      
      {/* Geo Location Meta Tags for India */}
      <meta name="geo.region" content="IN-GJ" />
      <meta name="geo.placename" content="Surat, Gujarat, India" />
      <meta name="geo.position" content="21.1702;72.8311" />
      <meta name="ICBM" content="21.1702, 72.8311" />
    </>
  );
};

export default SEOHead;